import React, { useState } from "react";
import { FiDownload } from "react-icons/fi";
import {
  AgreementWrapper,
  Header,
  HeaderContent,
  Title,
  Subtitle,
  MainContent,
  TabsContainer,
  Tab,
  ClausesContainer,
  ClauseItem,
  ClauseTitle,
  ClauseText,
  LegalSection,
  LegalTitle,
  LegalGrid,
  LegalItem,
  LegalLabel,
  LegalValue,
  LegalFooter,
  LegalFooterText,
} from "./RestaurantAgreement.elements";
import FullAgreement from "./FullAgreement";
import DownloadModal from "./DownloadModal";

const clauses = [
  {
    id: 1,
    title: "Naturaleza del Servicio e Intermediación Tecnológica",
    text: "KUSINA APP E.I.R.L. actúa exclusivamente como intermediario tecnológico entre el Aliado Comercial y los consumidores finales (Eaters), proporcionando una plataforma de conexión y gestión de pedidos. Kusina no es parte de la relación de consumo entre el Restaurante y el Eater, no produce ni comercializa los productos ofertados, y no asume en ningún caso la condición de vendedor, proveedor alimentario ni responsable tributario frente al consumidor. La emisión de comprobantes de pago (boletas de venta o facturas) a los consumidores finales constituye una obligación exclusiva e indelegable del Aliado Comercial, en su calidad de contribuyente y sujeto de la relación comercial directa con el Eater, conforme a la Ley del IGV y el Reglamento de Comprobantes de Pago (R.S. 007-99/SUNAT).",
  },
  {
    id: 2,
    title: "Comisión por Servicio de Intermediación",
    text: "El Aliado Comercial podrá operar bajo una de las siguientes modalidades, según lo pactado en el Anexo A: (a) Modalidad por Comisión Porcentual: Kusina retendrá una comisión fija del 20% sobre el valor total de cada orden procesada (pickup, dine-in y delivery), impuestos incluidos; o (b) Modalidad de Compra al Por Mayor: Kusina adquirirá del Aliado Comercial un volumen determinado de productos a un precio mayorista preferencial, pactado de mutuo acuerdo y registrado en el Anexo A. Kusina revenderá dichos productos al consumidor final al precio de venta al público fijado por el Aliado Comercial. En ambas modalidades, el Aliado Comercial deberá emitir el comprobante de pago al consumidor final por el precio de venta al público, conforme a la normativa tributaria vigente. La diferencia entre el precio mayorista y el precio de venta al público constituye un descuento comercial cuya carga tributaria es asumida por Kusina. La modalidad específica y sus condiciones quedan determinadas en el Anexo A suscrito al momento de la afiliación.",
  },
  {
    id: 3,
    title: "Facturación de Kusina al Aliado Comercial",
    text: "Al cierre de cada período de pago, KUSINA APP E.I.R.L. emitirá una factura electrónica al Aliado Comercial por concepto de «Servicio de Intermediación Tecnológica», por el monto equivalente a la comisión acumulada en dicho período. El depósito del monto neto al restaurante se efectuará una vez emitida dicha factura y descontada la comisión correspondiente. El Aliado Comercial no deberá emitir ningún comprobante a Kusina por este concepto.",
  },
  {
    id: 4,
    title: "Períodos y Días de Pago",
    text: "Los períodos y días de pago descritos en esta cláusula aplican exclusivamente a los Aliados Comerciales que operen bajo la Modalidad por Comisión Porcentual. Los pagos se realizan en dos cortes semanales: (i) las ventas generadas de lunes a miércoles serán liquidadas el viernes de la misma semana; (ii) las ventas generadas de jueves a domingo serán liquidadas el miércoles de la semana siguiente. En ambos casos, el depósito se acreditará en la cuenta bancaria registrada por el Aliado Comercial, previa emisión de la factura por parte de Kusina conforme a la cláusula anterior. Para los Aliados Comerciales que operen bajo la Modalidad de Compra al Por Mayor, Kusina realiza el pago al momento de la adquisición de los productos, por lo que no aplica el esquema de liquidación semanal.",
  },
  {
    id: 5,
    title: "Responsabilidad Sanitaria y Legal ante el Consumidor",
    text: "El Aliado Comercial es el único y exclusivo responsable, frente a los consumidores, las autoridades sanitarias y cualquier tercero, por la calidad, composición, inocuidad, condiciones bromatológicas e higiénico-sanitarias de los productos que comercializa. Cualquier reclamo, denuncia, proceso administrativo o acción judicial derivada de enfermedades transmitidas por alimentos (ETA), intoxicaciones, alergias u otros daños a la salud causados por el consumo de los productos del Aliado Comercial será de responsabilidad exclusiva de este último. Kusina queda expresamente excluida de toda responsabilidad civil, administrativa o penal en dichos supuestos, debiendo el Aliado Comercial mantener indemne a Kusina frente a cualquier pretensión de terceros vinculada a estos hechos.",
  },
  {
    id: 6,
    title: "Cancelaciones y Devoluciones",
    text: "Si el Aliado Comercial cancela una orden confirmada hasta cinco (5) minutos antes de la hora de entrega pactada, el personal de Kusina negociará con el consumidor final la retribución correspondiente, la cual consistirá como mínimo en el valor del delivery de dicha orden. Si el Aliado Comercial entrega un pedido erróneo o con productos distintos a los solicitados, el costo total del producto será asumido íntegramente por el Aliado Comercial. No generarán cargo las cancelaciones atribuibles al Eater o a causas de fuerza mayor debidamente acreditadas.",
  },
  {
    id: 7,
    title: "Obligaciones del Aliado Comercial",
    text: "El Aliado Comercial se obliga a: (i) mantener actualizado el menú, precios, horarios y disponibilidad en la plataforma; (ii) contar con todos los permisos, licencias sanitarias y autorizaciones municipales vigentes; (iii) cumplir la normativa en materia de inocuidad alimentaria; y (iv) informar a Kusina de cualquier cambio en su situación legal, tributaria u operativa.",
  },
  {
    id: 8,
    title: "Duración y Terminación",
    text: "El presente acuerdo tiene vigencia indefinida desde su suscripción. Cualquiera de las Partes podrá resolverlo unilateralmente mediante preaviso escrito de quince (15) días calendario. Kusina podrá resolver de forma inmediata y sin preaviso ante incumplimiento grave, conductas ilícitas o vulneración de normas sanitarias por parte del Aliado Comercial.",
  },
  {
    id: 9,
    title: "Confidencialidad y Protección de Datos",
    text: "Las Partes se obligan a mantener reserva sobre la información comercial, financiera y operativa intercambiada, por un plazo de dos (2) años desde la terminación del acuerdo. El tratamiento de datos personales se rige por la Ley N.º 29733 y su reglamento. El Aliado Comercial no podrá utilizar los datos de los Eaters para fines distintos a la atención de las órdenes.",
  },
];

const RestaurantAgreement = () => {
  const [activeTab, setActiveTab] = useState("resumen");
  const [showModal, setShowModal] = useState(false);

  return (
    <AgreementWrapper>
      <Header>
        <HeaderContent>
          <Title>Acuerdo Comercial de Cooperación</Title>
          <Subtitle>Términos y condiciones para operar con Kusina en Perú</Subtitle>
        </HeaderContent>
      </Header>

      <MainContent>
        <TabsContainer>
          <Tab active={activeTab === "resumen"} onClick={() => setActiveTab("resumen")}>
            Resumen
          </Tab>
          <Tab active={activeTab === "detalle"} onClick={() => setActiveTab("detalle")}>
            Acuerdo Completo
          </Tab>
          <Tab as="button" onClick={() => setShowModal(true)} style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "6px", color: "#1410DF" }}>
            <FiDownload size={16} />
            Descargar
          </Tab>
        </TabsContainer>

        {activeTab === "resumen" && (
          <>
            <ClausesContainer>
              {clauses.map((clause) => (
                <ClauseItem key={clause.id}>
                  <ClauseTitle>{clause.title}</ClauseTitle>
                  <ClauseText>{clause.text}</ClauseText>
                </ClauseItem>
              ))}
            </ClausesContainer>

            <LegalSection>
              <LegalTitle>Datos Legales de la Empresa</LegalTitle>
              <LegalGrid>
                <LegalItem>
                  <LegalLabel>Razón Social</LegalLabel>
                  <LegalValue>KUSINA APP E.I.R.L.</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Nombre Comercial</LegalLabel>
                  <LegalValue>KUSINA APP</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>RUC</LegalLabel>
                  <LegalValue>20613753983</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Tipo de Contribuyente</LegalLabel>
                  <LegalValue>Empresa Individual de Responsabilidad Limitada</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Domicilio Fiscal</LegalLabel>
                  <LegalValue>Av. Javier Padro Este Nro. 560 Int. 1302, Lima, Lima, San Isidro</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Actividad Económica</LegalLabel>
                  <LegalValue>Programación Informática (CIIU 6201)</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Correo Electrónico</LegalLabel>
                  <LegalValue>soporte@kusina.site</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Teléfono</LegalLabel>
                  <LegalValue>+51 973 834 813</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Fecha de Inscripción SUNARP</LegalLabel>
                  <LegalValue>05 de febrero de 2025</LegalValue>
                </LegalItem>
                <LegalItem>
                  <LegalLabel>Partida Registral</LegalLabel>
                  <LegalValue>15842416</LegalValue>
                </LegalItem>
              </LegalGrid>
              <LegalFooter>
                <LegalFooterText>
                  Este documento constituye el acuerdo comercial entre KUSINA APP E.I.R.L. y el restaurante.
                  Para consultas o aclaraciones, contactar a soporte@kusina.site
                </LegalFooterText>
              </LegalFooter>
            </LegalSection>
          </>
        )}

        {activeTab === "detalle" && <FullAgreement />}
      </MainContent>

      {showModal && <DownloadModal onClose={() => setShowModal(false)} />}
    </AgreementWrapper>
  );
};

export default RestaurantAgreement;
